export const setItem = (key, value) => { // 存储到本地缓存
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  window.localStorage.setItem(key, value)
}

export const getItem = (key) => { // 获取本地缓存数据
  const data = window.localStorage.getItem(key)
  try {
    return JSON.parse(data)
  } catch (err) {
    return data
  }
}

export const removeItem = (key) => { // 删除数据
  window.localStorage.removeItem(key)
}

export const removeAllItem = () => { // 清空数据
  window.localStorage.clear()
}
